module.exports = __webpack_public_path__ + "ef0122da1fd23bfc9e26e49328ecee47.jpeg";